import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/rubrics`;

/** `client` permite inyectar un apiClient acotado por área (ver BusinessUnitContext). */
export const createRubricsAPI = (client = apiClient) => ({
  async getCriteria(profileId) {
    const qs = profileId ? `?profile_id=${encodeURIComponent(profileId)}` : '';
    return client(`${BASE}/criteria${qs}`);
  },

  async getProfiles() {
    return client(`${BASE}/profiles`);
  },

  async listByOrganization(organizationId) {
    return client(`${BASE}/organizations/${organizationId}`);
  },

  async getById(id) {
    return client(`${BASE}/${id}`);
  },

  async create(data) {
    return client(`${BASE}/`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async update(id, data) {
    return client(`${BASE}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  async remove(id) {
    return client(`${BASE}/${id}`, {
      method: 'DELETE',
    });
  },
});

export const rubricsAPI = createRubricsAPI();

/**
 * Weighted score from raw scores (1–5) and profile-dependent weights.
 * Only scores are persisted; weights come from the selected commercialization profile.
 */
export function computeWeightedScore(criteria, scoreMap) {
  let numerator = 0;
  let denominator = 0;
  criteria.forEach((criterion) => {
    const raw = scoreMap[criterion.id];
    const score = raw === '' || raw == null ? null : Number(raw);
    if (!score || score <= 0) return;
    const weight = Number(criterion.weight_pct) || 0;
    numerator += weight * score;
    denominator += weight;
  });
  if (denominator <= 0) return null;
  return Math.round((numerator / denominator) * 100) / 100;
}

export function suggestedPriorityFromScore(weighted) {
  if (weighted == null || Number.isNaN(Number(weighted))) return '';
  const value = Number(weighted);
  if (value >= 4.2) return 'Alta prioridad';
  if (value >= 3.5) return 'Prioridad media-alta';
  if (value >= 2.8) return 'Prioridad media';
  return 'Baja prioridad';
}

export function applyProfileWeights(criteria, profile) {
  const weightByCriterion = new Map(
    (profile?.weights || []).map((item) => [Number(item.criterion_id), Number(item.weight_pct)])
  );
  return (criteria || []).map((criterion) => ({
    ...criterion,
    weight_pct: weightByCriterion.has(Number(criterion.id))
      ? weightByCriterion.get(Number(criterion.id))
      : Number(criterion.catalog_weight_pct ?? criterion.weight_pct) || 0,
  }));
}
